import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Select,
  Text,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Image,
} from "@chakra-ui/react";
import defaultImage from "../../assets/img/userimage.jpg";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { IoMdClose } from "react-icons/io";
import { use } from "react";

const RoomBookPrintModal = ({
  isOpen,
  onClose,
  customerId,
  onOpen,
  roomBookData,
}) => {
  // console.log(data,'data')
  const [printData, setPrintData] = useState([]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData3();
  }, [customerId]);
  const print = () => {
    handlePrint();
  };
  const handleClose = () => {
    onClose();
  };
  const scroll = "inside";

  return (
    <Modal
      width="full"
      size="7xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>RoomBook Data- {roomBookData?.name}</Text>
          <Button colorScheme="red" onClick={handleClose}>
            <IoMdClose />
          </Button>
        </ModalHeader>
        <ModalBody>
          {roomBookData ? (
            <Card
              mt={10}
              textAlign="center"
              boxShadow="dark-lg"
              ref={componentRef}
              width="794px"
              mx="auto"
            >
              <Text
                color="purple"
                fontSize="18px"
                fontFamily="sans-serif"
                mt={5}
              >
                Room Book Report
              </Text>
              <CardHeader
                display="flex"
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                gap={5}
                p={4}
                boxShadow="md"
              >
                <Box
                  color="purple"
                  fontSize="18px"
                  fontFamily="sans-serif"
                  textAlign="center"
                >
                  {printData.map((item) => (
                    <>
                      <Image
                        alignItems="center"
                        src={item.imageUrl}
                        w="220px"
                        h="100px"
                        mb={2}
                      />
                      <Text>{item.name}</Text>
                      <Text fontSize="10px">{item.adress}</Text>
                      <Text fontSize="10px">{item.phoneNo}</Text>
                      <Text fontSize="10px">{item.website}</Text>
                      <Text fontSize="10px">Email id:{item.email}</Text>
                      <Text fontSize="10px">Gst No:{item.gstNo}</Text>
                    </>
                  ))}
                </Box>
              </CardHeader>
              <CardBody
                display="flex"
                justifyContent="space-between"
                p={1}
                textAlign="left"
              >
                <TableContainer width="full">
                  <Table size="xsm" variant="striped" colorScheme="teal">
                    <TableCaption>Room Book Data</TableCaption>
                    <Thead

                    // Background color to avoid transparency when scrolling
                    >
                      <Tr>
                        <Th fontSize="6px">Name</Th>
                        <Th fontSize="6px">Registration</Th>
                        <Th fontSize="6px">Nationality</Th>
                        {/* <Th fontSize='6px'>Purpose</Th>
        
                     <Th fontSize='6px'>Date</Th> */}
                        <Th fontSize="6px">Address</Th>
                        <Th fontSize="6px">Phone No</Th>
                        {/* <Th fontSize='6px'>Arrived From</Th>
                     <Th fontSize='6px'>Next Destination</Th> */}
                        <Th fontSize="6px">Aadhar</Th>
                        <Th fontSize="6px">Image</Th>
                        <Th fontSize="6px">Aadhar Image</Th>
                        {/* <Th fontSize='6px'>Pan Image</Th> */}
                        {/* <Th fontSize='6px'>Driving License Image</Th> */}
                        <Th fontSize="6px">Voter Id</Th>
                        {/* <Th fontSize='6px'>Voter Image</Th> */}
                        {/* <Th fontSize='6px'>Goverment IssueId</Th>
                     <Th fontSize='6px'>Goverment IssueId Image</Th> */}

                        <Th fontSize="6px">CheckIn</Th>
                        <Th fontSize="6px">CheckOut</Th>
                        <Th fontSize="6px">PAX</Th>
                        <Th fontSize="6px">Adult</Th>
                        <Th fontSize="6px">Child</Th>
                        {/* <Th fontSize='6px'>Other</Th> */}
                        <Th fontSize="6px">Room No</Th>

                        <Th fontSize="6px">Category</Th>
                        <Th fontSize="6px">Booking By</Th>

                        {/* <Th fontSize='6px'>Single Rate</Th>
                     <Th fontSize='6px'>With Breakfast</Th>
                     <Th fontSize='6px'>With BreakfastLunchDinner</Th>
                     <Th fontSize='6px'>Extra Person</Th> */}
                        {/* <Th fontSize='6px'>Ac</Th>
                     <Th fontSize='6px'>Passport No</Th>
                     <Th fontSize='6px'>Issue Date</Th>
                     <Th fontSize='6px'>Date of Arrival</Th>
                     <Th fontSize='6px'>Place of Issue</Th>
                     <Th fontSize='6px'>Duration of stay in India</Th>
                     <Th fontSize='6px'>Visa No</Th>
                     <Th fontSize='6px'>Issue Date of Visa</Th>
                     <Th fontSize='6px'>Expiry Date</Th> */}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {roomBookData?.map((item, index) => (
                        <Tr key={index}>
                          <Td fontSize="6px">{item.name}</Td>
                          <Td fontSize="6px">{item.registration}</Td>
                          <Td fontSize="6px">{item.nationality}</Td>
                          {/* <Td fontSize='6px'>{item.purpose}</Td>
                       <Td fontSize='6px'>{item.date}</Td> */}
                          <Td fontSize="6px">{item.address}</Td>
                          <Td fontSize="6px">{item.phoneNo}</Td>
                          {/* <Td fontSize='6px'>{item.arrivedFrom}</Td>
                       <Td fontSize='6px'>{item.nextDestination}</Td> */}
                          <Td fontSize="6px">{item.adhar}</Td>
                          <Td fontSize="6px">
                            <Image
                              src={item.imageUrl ? item.imageUrl : defaultImage}
                              width={50}
                              height={50}
                            />
                          </Td>
                          <Td fontSize="6px">
                            <Image
                              src={item.adharUrl ? item.adharUrl : defaultImage}
                              width={50}
                              height={50}
                            />
                          </Td>
                          {/* <Td fontSize='6px'><Image src={item.panUrl?item.panUrl:defaultImage}  width={50} height={50}/></Td> */}
                          {/* <Td fontSize='6px'><Image src={item.drivingUrl}  width={50} height={50}/></Td> */}
                          <Td fontSize="6px">{item.voterId}</Td>
                          {/* <Td fontSize='6px'><Image src={item.voterUrl?item.voterUrl:defaultImage}  width={50} height={50}/></Td> */}
                          {/* <Td fontSize='6px'>{item.goverMentIssuedId}</Td>
                       <Td fontSize='6px'><Image src={item.govermentUrl}  width={50} height={50}/></Td> */}
                          <Td fontSize="6px">{item.checkIn}</Td>
                          <Td fontSize="6px">{item.checkOut}</Td>
                          <Td fontSize="6px">{item.pax}</Td>
                          <Td fontSize="6px">{item.adult}</Td>
                          <Td fontSize="6px">{item.child}</Td>
                          {/* <Td ><Table>
                         <Thead>
                         <Tr>
                           <Td fontSize='6px'>Name</Td>
                           <Td fontSize='6px'>Document</Td>
                           <Td fontSize='6px'> No</Td>
                           <Td fontSize='6px'>Image</Td>
                           
                           <Td fontSize='6px'>Relation</Td>
                           </Tr>
                         </Thead>
                         <Tbody>
                         {item.other.map((other, index) => {
         console.log(other.select,'select');  // Log the value of other.select
         return (
           <Tr key={index}>
             <Td fontSize='6px'>{other.name}</Td>
             <Td fontSize='6px'> {other.select?   `${other.select}` : ""}</Td>
             <Td fontSize='6px'>{other.adharNo}</Td>
             <Td fontSize='6px'><Image src={other.otherAdharUrl} /></Td>
             <Td fontSize='6px'>{other.relation}</Td>
           </Tr>
         );
       })}
       
       </Tbody>
       
                       </Table></Td> */}
                          <Td fontSize="6px">{item.roomNo}</Td>

                          <Td fontSize="6px">{item.category}</Td>
                          <Td fontSize="6px">{item.bookingBy}</Td>
                          {/* <Td fontSize='6px'>{item.singleRate?"Yes":"No"}</Td>
                       <Td fontSize='6px'>{item.withBreakfast?"Yes":"No"}</Td>
                       <Td fontSize='6px'>{item.withBreakfastLunchDinner?"Yes":"No"}</Td>
                       <Td fontSize='6px'>{item.extraPerson?"Yes":"No"}</Td> */}

                          {/* <Td fontSize='6px'>{item.ac}</Td>
                       <Td fontSize='6px'>{item.passport}</Td>
                       <Td fontSize='6px'>{item.issue}</Td>
                       <Td fontSize='6px'>{item.arrival}</Td>
                       <Td fontSize='6px'>{item.placeOfIssue}</Td>
                       <Td fontSize='6px'>{item.stay}</Td>
                       <Td fontSize='6px'>{item.visa}</Td>
                       <Td fontSize='6px'>{item.issueVisa}</Td>
                       <Td fontSize='6px'>{item.expiry}</Td> */}
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          ) : (
            ""
          )}

          <Box
            display="flex"
            flexDirection="row"
            justifyContent="end"
            alignItems="center"
            gap="3"
          >
            <Button as="b" colorScheme="blue" onClick={print}>
              Print
            </Button>
            <Button as="b" colorScheme="blue" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default RoomBookPrintModal;
